import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import Header from './components/Header';
import ProviderSelector from './components/ProviderSelector';
import StandardsBanner from './components/StandardsBanner';
import Assessment from './components/Assessment';
import Results from './components/Results';
import Footer from './components/Footer';
import WelcomeModal from './components/WelcomeModal';
import { CloudSecurityProvider } from './context/CloudSecurityContext';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    background: #0a0e27;
    color: #e0e6ed;
    line-height: 1.6;
    overflow-x: hidden;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  
  @media (max-width: 768px) {
    padding: 10px;
  }
`;

function App() {
  return (
    <CloudSecurityProvider>
      <GlobalStyle />
      <WelcomeModal />
      <Container>
        <Header />
        <ProviderSelector />
        <StandardsBanner />
        <Assessment />
        <Results />
      </Container>
      <Footer />
    </CloudSecurityProvider>
  );
}

export default App; 